"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncRouterMap = exports.default = exports.constantRouterMap = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireWildcard"));

var _vue = _interopRequireDefault(require("vue"));

var _vueRouter = _interopRequireDefault(require("vue-router"));

var _Layout = _interopRequireDefault(require("@/views/layout/Layout"));

var _meta;

_vue.default.use(_vueRouter.default);
/* Layout */


/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    perms: ['GET /aaa','POST /bbb']     will control the page perms (you can set multiple perms)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if true ,the page will no be cached(default is false)
  }
**/
var constantRouterMap = [{
  path: "/redirect",
  component: _Layout.default,
  hidden: true,
  children: [{
    path: "/redirect/:path*",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/redirect/index"));
      });
    }
  }]
}, {
  path: "/login",
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("@/views/login/index"));
    });
  },
  hidden: true
}, {
  path: "/auth-redirect",
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("@/views/login/authredirect"));
    });
  },
  hidden: true
}, {
  path: "/404",
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("@/views/errorPage/404"));
    });
  },
  hidden: true
}, {
  path: "/401",
  component: function component() {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("@/views/errorPage/401"));
    });
  },
  hidden: true
}, {
  path: "/tc",
  component: function component(resolve) {
    return require(['@/views/m/tc'], resolve);
  },
  hidden: true,
  meta: {
    title: 'a2-客诉图片上传'
  }
}, {
  path: "/privacy",
  component: function component(resolve) {
    return require(['@/views/m/privacy'], resolve);
  },
  hidden: true,
  meta: {
    title: '隐私说明'
  }
}, {
  path: "/qiyu",
  component: function component(resolve) {
    return require(['@/views/qiyu/qiyu'], resolve);
  },
  hidden: true,
  meta: {
    title: '七鱼客户端'
  }
}, {
  path: "/qiyuWo",
  component: function component(resolve) {
    return require(['@/views/qiyu/qiyuWo'], resolve);
  },
  hidden: true,
  meta: {
    title: '七鱼客户端-我的工单'
  }
}, {
  path: "",
  component: _Layout.default,
  redirect: "dashboard",
  children: [{
    path: "dashboard",
    component: function component(resolve) {
      return require(['@/views/dashboard/index'], resolve);
    },
    name: "Dashboard",
    meta: {
      title: "首页",
      noCache: false,
      icon: "dashboard",
      affix: true
    }
  }]
}];
/*
  const routerPush = Router.prototype.push;
  Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
} */

exports.constantRouterMap = constantRouterMap;

var _default = new _vueRouter.default({
  //mode: 'history', // require service support
  scrollBehavior: function scrollBehavior() {
    return {
      y: 0
    };
  },
  routes: constantRouterMap
});

exports.default = _default;
var asyncRouterMap = [{
  path: "/callcenter",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "callcenter",
  meta: {
    title: "电访中心",
    icon: "callcenter"
  },
  children: [{
    path: "callrecord",
    component: function component(resolve) {
      return require(['@/views/callcenter/calllogRecord'], resolve);
    },
    name: "callrecord",
    meta: {
      perms: ["GET /admin/calllogRecord/list", "POST /admin/calllogRecord/createWorkOrder"],
      title: "话务记录",
      noCache: false,
      icon: "call-record",
      keepAlive: true
    }
  }, {
    path: "customer",
    component: function component(resolve) {
      return require(['@/views/member/customer'], resolve);
    },
    name: "customer",
    meta: {
      perms: ["GET /admin/customer/list", "POST /admin/customer/createWorkOrder", "GET /admin/customer/detail", "POST /admin/customer/updateV2", "POST /admin/customer/create"],
      title: "客户管理",
      noCache: false,
      icon: "user",
      keepAlive: true
    }
  }, {
    path: "addCustomer/:id",
    component: function component(resolve) {
      return require(['@/views/member/addCustomer'], resolve);
    },
    name: "addCustomer",
    meta: {
      perms: ["GET /admin/customer/list", "POST /admin/customer/create"],
      title: "用户编辑",
      noCache: false,
      icon: "call-record",
      keepAlive: true
    },
    hidden: true
  } // {
  //   path: "im",
  //   component: (resolve) => require(['@/views/im/im'], resolve),
  //   name: "im",
  //   meta: {
  //     perms: [
  //       "GET /admin/customer/list",
  //       "POST /admin/customer/createWorkOrder",
  //       "GET /admin/customer/detail",
  //       "POST /admin/customer/updateV2",
  //       "POST /admin/customer/create"
  //     ],
  //     title: "在线客服",
  //     noCache: false,
  //     icon: "user",
  //     keepAlive: true
  //   }
  // }
  ]
}, {
  path: "/ob",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "OB",
  meta: {
    title: "OB工作台",
    icon: "ob"
  },
  children: [{
    path: "builtList",
    component: function component(resolve) {
      return require(['@/views/callcenter/builtList'], resolve);
    },
    name: "builtList",
    meta: {
      perms: ["GET /admin/builtList/detail", "GET /admin/builtList/getBuilt"],
      title: "电访任务",
      noCache: false,
      icon: "call-center",
      keepAlive: true
    }
  }, {
    path: "calllog",
    component: function component(resolve) {
      return require(['@/views/callcenter/calllog'], resolve);
    },
    name: "calllog",
    meta: {
      perms: ["GET /admin/calllog/list", "POST /admin/calllog/create", "POST /admin/calllog/update", "GET /admin/calllog/detail"],
      title: "电访记录",
      noCache: false,
      icon: "calllog",
      keepAlive: true
    }
  }, {
    path: "out",
    component: function component(resolve) {
      return require(['@/views/callcenter/callOB'], resolve);
    },
    name: "out",
    meta: {
      perms: ["GET /admin/builtList/detail", "GET /admin/builtList/getBuilt", "GET /admin/calllog/list", "POST /admin/calllog/create", "POST /admin/calllog/update"],
      title: "OB电访",
      noCache: false,
      icon: "calllog",
      keepAlive: true
    },
    hidden: true
  }]
}, {
  path: "/ib",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "IB",
  meta: {
    title: "IB工作台",
    icon: "ib"
  },
  children: [{
    path: "allWorkOrder",
    component: function component(resolve) {
      return require(['@/views/workOrder/allWorkOrder'], resolve);
    },
    name: "allWorkOrder",
    meta: {
      perms: ["GET /admin/workOrder/all"],
      title: "全部工单",
      noCache: false,
      icon: "all2",
      keepAlive: true
    }
  }, {
    path: "myWorkOrder",
    component: function component(resolve) {
      return require(['@/views/workOrder/myWorkOrder'], resolve);
    },
    name: "myWorkOrder",
    meta: {
      perms: ["GET /admin/workOrder/list", "POST /admin/workOrder/create", "POST /admin/workOrder/reportToFac", 'POST /admin/workOrder/reopen', 'POST /admin/workOrder/detail', 'POST /admin/workOrder/completed', 'POST /admin/workOrder/updateWorkOrder', 'POST /admin/workOrder/change', 'POST /admin/workOrder/append'],
      title: "我的工单",
      noCache: false,
      icon: "ticket_handle",
      keepAlive: true
    }
  }, {
    path: "addWorkOrder/:cusId/:ticketId",
    component: function component(resolve) {
      return require(['@/views/workOrder/compent/addWorkOrder'], resolve);
    },
    name: "addWorkOrder",
    meta: {
      perms: ["GET /admin/workOrder/list", "POST /admin/workOrder/create", "POST /admin/workOrder/reportToFac", 'POST /admin/workOrder/reopen', 'POST /admin/workOrder/detail', 'POST /admin/workOrder/completed', 'POST /admin/workOrder/updateWorkOrder', 'POST /admin/workOrder/change', 'POST /admin/workOrder/append'],
      title: "工单详细",
      noCache: false,
      icon: "ticket_handle",
      keepAlive: true
    },
    hidden: true
  }]
}, {
  path: "/exam",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "exam",
  meta: {
    title: "问卷调研",
    icon: "exam"
  },
  children: [{
    path: "examPaper",
    component: function component(resolve) {
      return require(['@/views/exam/examPaper'], resolve);
    },
    name: "examPaper",
    meta: {
      perms: ["GET /admin/examPaper/list", "POST /admin/examPaper/addExamPaper", "GET /admin/examPaper/getExamResultInfo", "POST /admin/examPaper/deleted", "POST /admin/examPaper/enable"],
      title: "问卷配置",
      noCache: false,
      icon: "market-view",
      keepAlive: true
    }
  }, {
    path: "examResult",
    component: function component(resolve) {
      return require(['@/views/exam/examResult'], resolve);
    },
    name: "examResult",
    meta: {
      perms: ["GET /admin/examResult/list", "POST /admin/examResult/addExamResult", "GET /admin/examResult/getExamResultInfo", "POST /admin/examResult/deleteExamResult"],
      title: "问卷结果",
      noCache: false,
      icon: "sms-flash",
      keepAlive: true
    }
  }]
}, {
  path: "/member",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "member",
  meta: {
    title: "客户运营",
    icon: "member"
  },
  children: [{
    path: "campaign",
    component: function component(resolve) {
      return require(['@/views/member/campaign'], resolve);
    },
    name: "campaign",
    meta: {
      perms: ["GET /admin/campaign/list", "POST /admin/campaign/create", // "GET /admin/campaign/read",
      "POST /admin/campaign/update", "POST /admin/campaign/delete", "GET /admin/campaign/readAssigned", "POST /admin/campaign/assigned"],
      title: "任务管理",
      noCache: false,
      icon: "market-campaign",
      keepAlive: true
    }
  }, {
    path: "label",
    component: function component(resolve) {
      return require(['@/views/member/label'], resolve);
    },
    name: "label",
    meta: {
      perms: ["GET /admin/dmLabel/list", "POST /admin/dmLabel/create", "POST /admin/dmLabel/update", "POST /admin/dmLabel/delete"],
      title: "标签管理",
      noCache: false,
      icon: "market-label",
      keepAlive: true
    }
  }, // {
  //   path: "activity",
  //   component: () => import("@/views/member/marketActivity"),
  //   name: "activity",
  //   meta: {
  //     perms: [
  //       "GET /admin/market/list",
  //       "POST /admin/market/create",
  //       "POST /admin/market/update",
  //       "POST /admin/market/delete",
  //       "GET /admin/market/result"
  //     ],
  //     title: "市场活动",
  //     noCache: true,
  //     icon: "market",
  //     keepAlive:true
  //   }
  // },
  {
    path: "profile",
    component: function component(resolve) {
      return require(['@/views/member/profile'], resolve);
    },
    name: "profile",
    meta: {
      perms: ["GET /admin/profile/list", "GET /admin/profile/etl", "POST /admin/profile/create", "POST /admin/profile/update", "POST /admin/profile/delete", "GET /admin/profile/download", "GET /admin/profile/copy" // "GET /admin/profile/all"
      ],
      title: "标签画像",
      noCache: false,
      icon: "market-view",
      keepAlive: true
    }
  }]
}, {
  path: "/stat",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "statManage",
  meta: {
    title: "统计报表",
    icon: "report"
  },
  children: [{
    path: "taskReport",
    component: function component(resolve) {
      return require(['@/views/stat/taskReport'], resolve);
    },
    name: "taskReport",
    meta: {
      perms: ["GET /admin/report/taskList"],
      title: "电访任务报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "taskReportDetail",
    component: function component(resolve) {
      return require(['@/views/stat/taskReportDetail'], resolve);
    },
    name: "taskReportDetail",
    meta: {
      perms: ["GET /admin/report/taskReportDetail"],
      title: "电访明细报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "ticketReport",
    component: function component(resolve) {
      return require(['@/views/stat/ticketReport'], resolve);
    },
    name: "ticketReport",
    meta: {
      perms: ["GET /admin/report/ticketList"],
      title: "工单汇总表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "ticketConsultReport",
    component: function component(resolve) {
      return require(['@/views/stat/ticketConsultReport'], resolve);
    },
    name: "ticketConsultReport",
    meta: {
      perms: ["GET /admin/report/ticketConsultList"],
      title: "咨询工单报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "ticketComplainReport",
    component: function component(resolve) {
      return require(['@/views/stat/ticketComplainReport'], resolve);
    },
    name: "ticketComplainReport",
    meta: {
      perms: ["GET /admin/report/ticketComplainList"],
      title: "投诉工单报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "examReport",
    component: function component(resolve) {
      return require(['@/views/stat/examReport'], resolve);
    },
    name: "examReport",
    meta: {
      perms: ["GET /admin/report/ticketConsultDetailList"],
      title: "问卷结果报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "smsReport",
    component: function component(resolve) {
      return require(['@/views/stat/smsReport'], resolve);
    },
    name: "smsReport",
    meta: {
      perms: ["GET /admin/report/smsReport"],
      title: "短信发送明细报表",
      noCache: false,
      keepAlive: true
    }
  }, {
    path: "customReport",
    component: function component(resolve) {
      return require(['@/views/stat/customReport'], resolve);
    },
    name: "customReport",
    meta: {
      perms: ["GET /admin/customReport/list", "POST /admin/customReport/delete", "GET /admin/customReport/download"],
      title: "自定义报表",
      noCache: false,
      keepAlive: true
    }
  }]
}, {
  path: "/config",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "configManage",
  meta: {
    title: "配置管理",
    icon: "edit"
  },
  children: [{
    path: "franProvince",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/franProvince"));
      });
    },
    name: "franProvince",
    meta: {
      perms: ["POST /admin/franProvince/create", "POST /admin/franProvince/update", "POST /admin/franProvince/delete"],
      title: "加盟提醒邮箱",
      noCache: false,
      icon: "product-comment",
      keepAlive: true
    }
  }, {
    path: "builtRecycle",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/builtRecycle"));
      });
    },
    name: "builtRecycle",
    meta: {
      perms: ["GET /admin/builtRecycle/list", "POST /admin/builtRecycle/closed"],
      title: "任务回收",
      noCache: false,
      icon: "ums-menu",
      keepAlive: true
    }
  }, {
    path: "taskImport",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/taskImport"));
      });
    },
    name: "taskImport",
    meta: {
      perms: ["POST /admin/upload/uploadExcel", "GET /admin/upload/list"],
      title: "任务导入",
      noCache: false,
      icon: "product-add",
      keepAlive: true
    }
  }, {
    path: "workOrderConsult",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/workOrderConsult"));
      });
    },
    name: "workOrderConsult",
    meta: {
      perms: ["GET /admin/workOrderConsult/list", "POST /admin/workOrderConsult/create", "GET /admin/workOrderConsult/read", "POST /admin/workOrderConsult/update", "POST /admin/workOrderConsult/delete"],
      title: "咨询类型",
      noCache: false,
      icon: "ticket_consult",
      keepAlive: true
    }
  }, {
    path: "workOrderResult",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/workOrderResult"));
      });
    },
    name: "workOrderResult",
    meta: {
      perms: ["GET /admin/workOrderResult/list", "POST /admin/workOrderResult/create", "GET /admin/workOrderResult/read", "POST /admin/workOrderResult/update", "POST /admin/workOrderResult/delete"],
      title: "处理结果",
      noCache: false,
      icon: "ticket-result",
      keepAlive: true
    }
  }, {
    path: "goods",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/goods"));
      });
    },
    name: "goods",
    meta: {
      perms: ["GET /admin/product/list", "POST /admin/product/create", "POST /admin/product/update", "POST /admin/product/delete"],
      title: "产品配置",
      noCache: false,
      icon: "product",
      keepAlive: true
    }
  }, {
    path: "shop",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/shop"));
      });
    },
    name: "shop",
    meta: {
      perms: ["GET /admin/shop/list", "POST /admin/shop/create", "GET /admin/shop/read", "POST /admin/shop/update", "POST /admin/shop/delete"],
      title: "门店配置",
      noCache: false,
      icon: "home",
      keepAlive: true
    }
  }, {
    path: "shopEmail",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/shopEmail"));
      });
    },
    name: "shopEmail",
    meta: {
      perms: ["GET /admin/shopEmail/list", "POST /admin/shopEmail/create", "POST /admin/shopEmail/update", "POST /admin/shopEmail/delete"],
      title: "门店邮箱配置",
      noCache: false,
      icon: "home",
      keepAlive: true
    }
  }, // {
  //   path: "callconfig",
  //   component: () => import("@/views/config/callConfig"),
  //   name: "callconfig",
  //   meta: {
  //     perms: ["GET /admin/config/call", "POST /admin/config/call"],
  //     title: "外拨配置",
  //     noCache: false,
  //     icon: "order-setting",
  //     keepAlive: true
  //   }
  // },
  {
    path: "emailConfig",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/email"));
      });
    },
    name: "emailConfig",
    meta: {
      perms: ["GET /admin/emailConfig/logList", "GET /admin/emailConfig/list", "POST /admin/emailConfig/create", "GET /admin/emailConfig/read", "POST /admin/emailConfig/update", "POST /admin/emailConfig/delete"],
      title: "邮件配置",
      noCache: false,
      icon: "email",
      keepAlive: true
    }
  }, {
    path: "sms",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/sms"));
      });
    },
    name: "sms",
    meta: {
      perms: ["GET /admin/sendSms/listSms", "POST /admin/sendSms/create", "POST /admin/sendSms/update", "POST /admin/sendSms/delete"],
      title: "短信配置",
      noCache: false,
      icon: "message",
      keepAlive: true
    }
  }, {
    path: "channel",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/channel"));
      });
    },
    name: "channel",
    meta: {
      perms: ["GET /admin/channel/list", "POST /admin/channel/create"],
      title: "渠道来源",
      noCache: false,
      icon: "guide",
      keepAlive: true
    }
  }, {
    path: "baseData",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/config/baseData"));
      });
    },
    name: "baseData",
    meta: {
      perms: ["GET /admin/baseData/list", "POST /admin/baseData/create", "POST /admin/baseData/delete"],
      title: "基础数据",
      noCache: false,
      icon: "star",
      keepAlive: true
    }
  } // {
  //   path: "buyChannel",
  //   component: () => import("@/views/config/buyChannel"),
  //   name: "buyChannel",
  //   meta: {
  //     perms: ["GET /admin/buyChannel/list", "POST /admin/buyChannel/create", "POST /admin/buyChannel/delete"],
  //     title: "购买渠道",
  //     noCache: true,
  //     icon: "tab",
  //     keepAlive: true
  //   }
  // }
  ]
}, {
  path: "/sys",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  name: "sysManage",
  meta: {
    title: "系统管理",
    icon: "setting"
  },
  children: [{
    path: "admin",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sys/admin"));
      });
    },
    name: "admin",
    meta: (_meta = {
      perms: ["GET /admin/admin/list", "POST /admin/admin/create", "POST /admin/admin/update", "POST /admin/admin/delete", "POST /admin/admin/enable"],
      noCache: false,
      title: "管理员"
    }, (0, _defineProperty2.default)(_meta, "noCache", true), (0, _defineProperty2.default)(_meta, "icon", "ums-admin"), _meta)
  }, {
    path: "role",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sys/role"));
      });
    },
    name: "role",
    meta: {
      perms: ["GET /admin/role/list", "POST /admin/role/create", "POST /admin/role/update", "POST /admin/role/delete", "GET /admin/role/permissions", "POST /admin/role/permissions"],
      title: "角色管理",
      noCache: false,
      icon: "ums-menu",
      keepAlive: true
    }
  }, {
    path: "drmLog",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sys/drm"));
      });
    },
    name: "drmLog",
    meta: {
      perms: ["GET /admin/drmLog/drmList"],
      title: "DRM日志",
      noCache: false,
      icon: "link",
      keepAlive: true
    }
  }, {
    path: "log",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sys/log"));
      });
    },
    name: "log",
    meta: {
      perms: ["GET /admin/log/list"],
      title: "操作日志",
      noCache: false,
      icon: "icon",
      keepAlive: true
    }
  }, {
    path: "os",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sys/os"));
      });
    },
    name: "os",
    meta: {
      perms: ["GET /admin/storage/list", "POST /admin/storage/create", "POST /admin/storage/update", "POST /admin/storage/delete"],
      title: "对象存储",
      noCache: false,
      icon: "documentation",
      keepAlive: true
    }
  }]
}, {
  path: "/profile",
  component: _Layout.default,
  redirect: "noredirect",
  alwaysShow: true,
  children: [// {
  //   path: "password",
  //   component: () => import("@/views/profile/password"),
  //   name: "password",
  //   meta: { title: "修改密码", noCache: true }
  // },
  {
    path: "notice",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/profile/notice"));
      });
    },
    name: "notice",
    meta: {
      title: "通知中心",
      noCache: true
    }
  }],
  hidden: true
}, {
  path: "*",
  redirect: "/404",
  hidden: true
}];
exports.asyncRouterMap = asyncRouterMap;